"use client" // This is needed for client-side hooks like useState, useEffect, useRef

import { useEffect, useRef } from "react"
import "./WebBenefits.css"

const ScopingBenefits = () => {
  const benefits = [
    {
      iconSrc: "/insights.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Clear Guideline Icon",
      title: "GET VALUABLE INSIGHTS",
      description: "Our specialized web design and development team will advise you the best framework suitable for your project, build a roadmap with prioritized features and set deadlines.",
    },
    {
      iconSrc: "/rocket.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Plan Costs Icon",
      title: "A PRODUCT READY TO LAUNCH",
      description: "Get an outstanding, responsive digital product 2x faster and ready to be tested by your users.",
    },
    {
      iconSrc: "/clock.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Business Plan Icon",
      title: "REDUCE UP TO 60% on COSTS",
      description: "Our Agile Development Process lets you plan and manage realistic schedules, saving you time, and redesigning costs - save up 60% on development costs.",
    },
    {
      iconSrc: "/target.webp?height=48&width=48", // Placeholder for your icon
      iconAlt: "Focus Icon",
      title: "FOCUS ON YOUR BUSINESS GOALS",
      description:
        "Our specialized professionals will advise you the best framework suitable for your project, create a roadmap with prioritized features and set deadlines.",
    },
  ]

  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([]) // Use an array of refs for multiple cards

  useEffect(() => {
    console.log("ScopingBenefits component mounted. Setting up IntersectionObserver.")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            console.log(`Element ${entry.target.className} is now visible.`)
            observer.unobserve(entry.target) // Stop observing once visible
          }
        })
      },
      { threshold: 0.1 }, // Trigger when 10% of the element is visible
    )

    // Observe header and description
    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      console.log("ScopingBenefits component unmounted. Cleaning up IntersectionObserver.")
      // Clean up observers on unmount
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="scoping-benefits-container" id="benefits">
      <div className="container">
      <div className="scoping-benefits-wrapper">
        {/* Header Section */}
        <div className="scoping-benefits-header">
          <h2 className="scoping-benefits-title456 animate-left" ref={headerRef}>
            DEVELOP TRULY UNIQUE
            
            <span className="scoping-benefits-highlight"> WEB EXPERIENCES</span>
          </h2>
          <p className="scoping-benefits-description animate-left" ref={descriptionRef}>
            Build user-centric websites, web solutions and custom web applications using our unique development services and processes, and our skilled team of developers and designers.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="scoping-benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="scoping-benefit-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }} // Staggered animation
            >
              <div className="scoping-benefit-icon">
                <img src={benefit.iconSrc || "/placeholder.svg"} alt={benefit.iconAlt} className="scoping-icon-image" />
              </div>
              <h3 className="scoping-benefit-card-title">{benefit.title}</h3>
              <p className="scoping-benefit-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  )
}

export default ScopingBenefits
